module.exports = __webpack_public_path__ + "static/assets/ea77f92a0013a0c201683e9c1a28bbbf.svg";